"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureAvailable = void 0;
/**
 * Check if a feature is available in the provided plan.
 *
 * @param plan The Plan object retrieved from the billing-service.
 * @param feature The feature availability to evaluate.
 *
 * @return `true` if the feature is available, `false` otherwise.
 */
const isFeatureAvailable = (plan, feature) => {
    if (!plan) {
        return false;
    }
    return plan.features.includes(feature);
};
exports.isFeatureAvailable = isFeatureAvailable;
